// src/pages/ResetPage.js
import React from 'react';
import PasswordReset from '../components/PasswordReset';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Box } from '@mui/material';

const ResetPage = () => {
  return (
    <Box>
      <PasswordReset />
      <Box textAlign="center" sx={{ mt: 2 }}>
        <Link component={RouterLink} to="/" variant="body2">
          Back to Login
        </Link>
      </Box>
    </Box>
  );
};

export default ResetPage;